import React from 'react';
import classNames from "classnames";
import styles from "./interstitial-ad.module.scss"
import {Clear} from "../../icons/clear";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../app/consts/colors";

export const InterstitialAdCloseButton = ({onClose}) => {
  const imageButtonProps = {
    style: {
      fill: useThemeColor(COLORS.blackPrimary),
      width: 24,
      height: 24,
    }
  }

  return (
    <div className={classNames(styles.button_container)} onClick={() => onClose(false)}>
      <div className={classNames(styles.button)}>
        <Clear {...imageButtonProps}/>
      </div>
    </div>
  )
}
